import * as setup from '@/setup';
import Button from '@/objects/button';
import Header from '@/objects/header';
import { HEADER_HEIGHT } from '@/constants';
import { getUser } from '@/utils/auth';
import * as audio from '@/utils/audio';

/**
 * Scena che mostra i dettagli completi di una sfida conclusa
 * Visualizza barre proporzionali stile Ruzzle per ogni metrica:
 * 1. Punti lettere
 * 2. Tempo rimasto
 * 3. Aiuti utilizzati
 * 4. Punteggio totale
 */
export default class ChallengeDetail extends Phaser.Scene {
	constructor() {
		super({key: 'ChallengeDetail'});
		this.challenge = null;
		this.isSentChallenge = false;
		this.currentUserNickname = 'Tu';
		// Punteggi della sfida calcolati dal backend (con formula corretta)
		this.challengerChallengeScore = null;
		this.challengedChallengeScore = null;
		this.challengeWinner = null;
	}

	init(data) {
		console.log('ChallengeDetail init called with data:', data);
		if (data) {
			this.challenge = data.challenge;
			this.isSentChallenge = data.isSentChallenge || false;

			// Se viene passato anche il result dall'API, estrai i dati in formato compatibile
			if (data.result) {
				console.log('ChallengeDetail: result data available, mapping to challenge format');
				// Mappa i dati del result al formato atteso da createDetailView
				// L'API restituisce: result.challenger.user, result.challenger.round, result.challenged.user, result.challenged.round
				if (!this.challenge.user && data.result.challenger && data.result.challenger.user) {
					this.challenge.user = data.result.challenger.user;
				}
				if (!this.challenge.round && data.result.challenger && data.result.challenger.round) {
					this.challenge.round = data.result.challenger.round;
				}
				if (!this.challenge.friend && data.result.challenged && data.result.challenged.user) {
					this.challenge.friend = data.result.challenged.user;
				}
				if (!this.challenge.challenged_round && data.result.challenged && data.result.challenged.round) {
					this.challenge.challenged_round = data.result.challenged.round;
				}
				// Salva i punteggi della sfida calcolati dal backend (formula corretta)
				if (data.result.challenger && typeof data.result.challenger.score === 'number') {
					this.challengerChallengeScore = data.result.challenger.score;
				}
				if (data.result.challenged && typeof data.result.challenged.score === 'number') {
					this.challengedChallengeScore = data.result.challenged.score;
				}
				if (data.result.winner) {
					this.challengeWinner = data.result.winner;
				}
				console.log('ChallengeDetail: punteggi sfida - challenger:', this.challengerChallengeScore, 'challenged:', this.challengedChallengeScore, 'winner:', this.challengeWinner);
			}
		} else {
			this.challenge = null;
			this.isSentChallenge = false;
		}
	}

	create() {
		console.log('ChallengeDetail create() started');

		// Aggiungi listener per monitorare quando la scena viene fermata
		var self = this;
		this.events.on('shutdown', function() {
			console.log('ChallengeDetail SHUTDOWN event fired');
			console.trace('Shutdown stack trace');
		});
		this.events.on('destroy', function() {
			console.log('ChallengeDetail DESTROY event fired');
		});

		try {
			var width = this.sys.game.config.width;
			var height = this.sys.game.config.height;
			var centerX = width / 2;

			// Ottieni nickname utente corrente
			var currentUser = getUser();
			if (currentUser && currentUser.nickname) {
				this.currentUserNickname = currentUser.nickname;
			}
			console.log('ChallengeDetail: currentUserNickname =', this.currentUserNickname);

			// Sfondo del gioco
			console.log('ChallengeDetail: adding background');
			this.add
				.image(centerX, height / 2, 'background')
				.setOrigin(0.5, 0.5);

			// Header
			console.log('ChallengeDetail: creating header');
			this.createGameHeader(centerX);

			// Se non ci sono dati, mostra errore
			if (!this.challenge) {
				console.log('ChallengeDetail: no challenge data, showing error');
				this.showError('Dati sfida non disponibili');
				return;
			}

			// Crea la visualizzazione dei dettagli
			console.log('ChallengeDetail: creating detail view');
			this.createDetailView(centerX);

			console.log('ChallengeDetail create() completed successfully');

			// Verifica lo stato delle scene dopo 100ms
			var self = this;
			setTimeout(function() {
				var activeScenes = self.scene.manager.getScenes(true).map(function(s) { return s.scene.key; });
				console.log('Active scenes after 100ms:', activeScenes);
				console.log('ChallengeDetail scene active:', self.scene.isActive());
				console.log('ChallengeDetail scene visible:', self.scene.isVisible());
			}, 100);
		} catch (e) {
			console.error('ChallengeDetail create() error:', e);
			console.error('Stack trace:', e.stack);
		}
	}

	/**
	 * Crea l'header della scena con il pulsante indietro e il titolo.
	 *
	 * @param {number} centerX - Posizione X centrale.
	 */
	createGameHeader(centerX) {
		var headerY = HEADER_HEIGHT / 2;

		// Header con componente riutilizzabile
		new Header(this, 'DETTAGLIO SFIDA');

		// Pulsante back (icona)
		var backArrow = this.add.image(40, headerY, 'back-icon');
		backArrow.setOrigin(0, 0.5);
		backArrow.setInteractive({ useHandCursor: true });

		var self = this;
		backArrow.on('pointerup', function() {
			audio.playSound(self, 'button-click');
			self.scene.start('Challenge');
		});
	}

	createDetailView(centerX) {
		var width = this.sys.game.config.width;
		var startY = HEADER_HEIGHT + 30;

		// Ottieni i dati dei giocatori
		var challenge = this.challenge;
		// === TITOLO DEL DITLOIDE ===
		// Il titolo viene dal dict associato al round
		var ditloideTitle = '';
		if (challenge.round && challenge.round.dict && challenge.round.dict.title) {
			ditloideTitle = challenge.round.dict.title;
		} else if (challenge.challenged_round && challenge.challenged_round.dict && challenge.challenged_round.dict.title) {
			ditloideTitle = challenge.challenged_round.dict.title;
		}

		if (ditloideTitle) {
			// Crea un testo temporaneo per calcolare l'altezza necessaria
			var tempText = this.add.text(0, 0, ditloideTitle.toUpperCase(), {
				fontSize: 28,
				fontFamily: 'Luckiest Guy',
				fill: '#FFD700',
				align: 'center',
				wordWrap: { width: width - 80, useAdvancedWrap: true }
			});
			var textHeight = tempText.getBounds().height;
			tempText.destroy();

			var bgHeight = Math.max(60, textHeight + 30);

			// Sfondo blu con bordo giallo come i tab dei giochi (FILM, LIBRI, CANZONI)
			var titleBg = this.add.rectangle(
				centerX,
				startY + bgHeight / 2 - 10,
				width - 40,
				bgHeight,
				0x2a7a9a,
				1
			);
			titleBg.setStrokeStyle(2, 0xffd700);

			// Crea il testo DOPO lo sfondo per renderizzarlo sopra
			var titleText = this.add.text(centerX, startY + bgHeight / 2 - textHeight / 2, ditloideTitle.toUpperCase(), {
				fontSize: 28,
				fontFamily: 'Luckiest Guy',
				fill: '#FFD700',
				align: 'center',
				wordWrap: { width: width - 80, useAdvancedWrap: true }
			}).setOrigin(0.5, 0);

			// Sposta la posizione di partenza per gli altri elementi
			startY += bgHeight + 20;
		}

		// Determina chi sono io confrontando l'ID utente corrente con gli utenti nel challenge
		// Questo è più robusto del flag isSentChallenge
		var currentUser = getUser();
		var currentUserId = currentUser ? parseInt(currentUser.id) : null;

		// Il challenger è challenge.user, il challenged è challenge.friend
		// Se il mio ID corrisponde a challenge.user.id, sono il challenger (ho inviato la sfida)
		// Uso parseInt per evitare problemi di tipo (stringa vs numero)
		var iAmChallenger = false;
		if (challenge.user && challenge.user.id) {
			iAmChallenger = currentUserId === parseInt(challenge.user.id);
		} else if (challenge.round && challenge.round.user_id) {
			// Fallback: il round.user_id è l'ID del challenger
			iAmChallenger = currentUserId === parseInt(challenge.round.user_id);
		} else {
			// Ultimo fallback: usa il flag isSentChallenge
			iAmChallenger = this.isSentChallenge;
		}

		console.log('ChallengeDetail: currentUserId:', currentUserId,
			'challenge.user.id:', challenge.user ? challenge.user.id : 'N/A',
			'challenge.round.user_id:', challenge.round ? challenge.round.user_id : 'N/A',
			'challenge.friend.id:', challenge.friend ? challenge.friend.id : 'N/A',
			'iAmChallenger:', iAmChallenger,
			'isSentChallenge:', this.isSentChallenge);

		// Determina chi è chi
		var myNickname = 'TU';
		var otherUser = iAmChallenger ? challenge.friend : challenge.user;
		var otherNickname = (otherUser && otherUser.nickname) ? otherUser.nickname : 'Avversario';

		// I round
		var myRound = iAmChallenger ? challenge.round : challenge.challenged_round;
		var otherRound = iAmChallenger ? challenge.challenged_round : challenge.round;

		// Calcola i punteggi della sfida (usa i punteggi calcolati dal backend se disponibili)
		// I punteggi della sfida usano la formula: (letter_points * 10) + time_remaining - help_costs
		var myChallengeScore, otherChallengeScore;
		if (this.challengerChallengeScore !== null && this.challengedChallengeScore !== null) {
			// Usa i punteggi calcolati dal backend
			// challengerChallengeScore è sempre il punteggio di chi ha INVIATO la sfida
			// challengedChallengeScore è sempre il punteggio di chi ha RICEVUTO la sfida
			myChallengeScore = iAmChallenger ? this.challengerChallengeScore : this.challengedChallengeScore;
			otherChallengeScore = iAmChallenger ? this.challengedChallengeScore : this.challengerChallengeScore;
			console.log('ChallengeDetail: usando punteggi sfida dal backend - mio:', myChallengeScore, 'altro:', otherChallengeScore);
		} else {
			// Fallback ai punteggi del round (per retrocompatibilità)
			myChallengeScore = (myRound && myRound.score !== null) ? myRound.score : 0;
			otherChallengeScore = (otherRound && otherRound.score !== null) ? otherRound.score : 0;
			console.log('ChallengeDetail: usando punteggi round (fallback) - mio:', myChallengeScore, 'altro:', otherChallengeScore);
		}

		// Determina vincitore usando i punteggi della sfida
		var iWon = myChallengeScore > otherChallengeScore;
		var isDraw = myChallengeScore === otherChallengeScore;

		// Estrai i dettagli della challenge (se disponibili)
		var myDetails = (myRound && myRound.challenge_details) ? myRound.challenge_details : {
			letter_points: myChallengeScore,
			time_remaining: 0,
			helps_used: 0,
			total_score: myChallengeScore
		};
		var otherDetails = (otherRound && otherRound.challenge_details) ? otherRound.challenge_details : {
			letter_points: otherChallengeScore,
			time_remaining: 0,
			helps_used: 0,
			total_score: otherChallengeScore
		};

		// === AVATAR E NICKNAME ===
		var avatarY = startY + 30;
		var avatarSize = 50;
		var leftX = width * 0.25;
		var rightX = width * 0.75;

		// Avatar sinistro (io)
		var leftAvatar = this.add.graphics();
		leftAvatar.fillStyle(iWon ? 0x4CAF50 : (isDraw ? 0x808080 : 0xE74C3C), 1);
		leftAvatar.fillCircle(leftX, avatarY, avatarSize / 2);
		leftAvatar.lineStyle(3, 0xFFFFFF, 1);
		leftAvatar.strokeCircle(leftX, avatarY, avatarSize / 2);

		this.add.text(leftX, avatarY, iWon ? '🏆' : '😊', {
			fontSize: avatarSize * 0.55
		}).setOrigin(0.5);

		// Nickname sinistro
		this.add.text(leftX, avatarY + avatarSize / 2 + 30, myNickname.toUpperCase(), {
			fontSize: 44,
			fontFamily: 'Luckiest Guy',
			fill: '#333333',
			fontStyle: 'bold'
		}).setOrigin(0.5);

		// Avatar destro (avversario)
		var rightAvatar = this.add.graphics();
		rightAvatar.fillStyle(!iWon && !isDraw ? 0x4CAF50 : (isDraw ? 0x808080 : 0xE74C3C), 1);
		rightAvatar.fillCircle(rightX, avatarY, avatarSize / 2);
		rightAvatar.lineStyle(3, 0xFFFFFF, 1);
		rightAvatar.strokeCircle(rightX, avatarY, avatarSize / 2);

		this.add.text(rightX, avatarY, (!iWon && !isDraw) ? '🏆' : '😎', {
			fontSize: avatarSize * 0.55
		}).setOrigin(0.5);

		// Nickname destro
		this.add.text(rightX, avatarY + avatarSize / 2 + 30, otherNickname.toUpperCase(), {
			fontSize: 44,
			fontFamily: 'Luckiest Guy',
			fill: '#333333',
			fontStyle: 'bold'
		}).setOrigin(0.5);

		// === BARRE PROPORZIONALI STILE RUZZLE ===
		var barStartY = avatarY + avatarSize / 2 + 115;
		var barHeight = 70;
		var barSpacing = 130;
		var barPadding = 20; // Margine laterale
		var totalBarWidth = width - (barPadding * 2);

		// Metriche da visualizzare
		// Formula Punteggio Sfida: (letter_points * 10) + time_remaining - help_costs
		// I punti lettere sono già moltiplicati per 10
		var letterWeight = 10;
		var metrics = [
			{
				label: 'Punti Lettere',
				myValue: (myDetails.letter_points || myDetails.score || 0) * letterWeight,
				otherValue: (otherDetails.letter_points || otherDetails.score || 0) * letterWeight,
				higherIsBetter: true
			},
			{
				label: 'Tempo Rimasto',
				myValue: myDetails.time_remaining || 0,
				otherValue: otherDetails.time_remaining || 0,
				higherIsBetter: true
			},
			{
				label: 'Costo Aiuti',
				myValue: myDetails.help_costs || 0,
				otherValue: otherDetails.help_costs || 0,
				higherIsBetter: false
			},
			{
				label: 'Punteggio Sfida',
				myValue: myChallengeScore,
				otherValue: otherChallengeScore,
				higherIsBetter: true
			}
		];

		var self = this;
		metrics.forEach(function(metric, index) {
			var y = barStartY + index * barSpacing;
			self.createProportionalBar(
				barPadding,
				y,
				totalBarWidth,
				barHeight,
				metric.label,
				metric.myValue,
				metric.otherValue,
				metric.higherIsBetter,
				metric.suffix || ''
			);
		});

		// === RISULTATO FINALE ===
		var resultY = barStartY + metrics.length * barSpacing + 25;
		var resultText = '';
		var resultColor = '#FFFFFF';

		if (iWon) {
			resultText = 'HAI VINTO!';
			resultColor = '#4CAF50';
		} else if (isDraw) {
			resultText = 'PAREGGIO';
			resultColor = '#FFD700';
		} else {
			resultText = 'HAI PERSO';
			resultColor = '#E74C3C';
		}

		// Sfondo per il risultato
		var resultBg = this.add.graphics();
		resultBg.fillStyle(0xFFFFFF, 0.9);
		resultBg.fillRoundedRect(centerX - 120, resultY - 20, 240, 45, 10);

		this.add.text(centerX, resultY, resultText, {
			fontSize: 28,
			fontFamily: 'Luckiest Guy',
			fill: resultColor
		}).setOrigin(0.5);
	}

	/**
	 * Crea una barra proporzionale stile Ruzzle
	 * Due barre contigue, larghezza proporzionale ai valori
	 */
	createProportionalBar(x, y, totalWidth, height, label, myValue, otherValue, higherIsBetter, suffix) {
		var graphics = this.add.graphics();

		// Calcola proporzioni
		var total = myValue + otherValue;
		var myWidth, otherWidth;

		if (total === 0) {
			// Se entrambi sono 0, dividi equamente
			myWidth = totalWidth / 2;
			otherWidth = totalWidth / 2;
		} else {
			myWidth = (myValue / total) * totalWidth;
			otherWidth = (otherValue / total) * totalWidth;
		}

		// Larghezza minima per mostrare il testo
		var minWidth = 50;
		if (myWidth < minWidth && myValue > 0) {
			myWidth = minWidth;
			otherWidth = totalWidth - myWidth;
		}
		if (otherWidth < minWidth && otherValue > 0) {
			otherWidth = minWidth;
			myWidth = totalWidth - otherWidth;
		}

		// Determina i colori in base a chi è migliore
		var myBetter = higherIsBetter
			? myValue > otherValue
			: myValue < otherValue;
		var otherBetter = higherIsBetter
			? otherValue > myValue
			: otherValue < myValue;
		var equal = myValue === otherValue;

		// Colori: verde per chi è migliore, rosso per chi è peggiore, grigio per pareggio
		var myColor = equal ? 0x808080 : (myBetter ? 0x4CAF50 : 0xE74C3C);
		var otherColor = equal ? 0x808080 : (otherBetter ? 0x4CAF50 : 0xE74C3C);

		// Label come titolo sopra la barra
		this.add.text(x + totalWidth / 2, y - 30, label, {
			fontSize: 44,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF'
		}).setOrigin(0.5);

		// Barra sinistra (io) - angoli arrotondati solo a sinistra
		graphics.fillStyle(myColor, 1);
		if (otherWidth === 0) {
			// Barra completa con tutti gli angoli arrotondati
			graphics.fillRoundedRect(x, y, myWidth, height, 5);
		} else {
			// Solo angoli sinistri arrotondati
			graphics.fillRoundedRect(x, y, myWidth + 5, height, { tl: 5, tr: 0, bl: 5, br: 0 });
			// Riempie l'area extra per evitare gap
			graphics.fillRect(x + myWidth, y, 5, height);
		}

		// Barra destra (avversario) - angoli arrotondati solo a destra
		graphics.fillStyle(otherColor, 1);
		if (myWidth === 0) {
			// Barra completa con tutti gli angoli arrotondati
			graphics.fillRoundedRect(x, y, otherWidth, height, 5);
		} else {
			// Solo angoli destri arrotondati
			graphics.fillRoundedRect(x + myWidth - 5, y, otherWidth + 5, height, { tl: 0, tr: 5, bl: 0, br: 5 });
			// Riempie l'area extra per evitare gap
			graphics.fillRect(x + myWidth - 5, y, 5, height);
		}

		// Bordo esterno
		graphics.lineStyle(2, 0x333333, 0.3);
		graphics.strokeRoundedRect(x, y, totalWidth, height, 5);

		// Testo valori all'interno delle barre
		var myValueStr = String(myValue) + suffix;
		var otherValueStr = String(otherValue) + suffix;

		// Valore sinistro (io) - 1% dal bordo sinistro
		this.add.text(x + totalWidth * 0.01, y + height / 2, myValueStr, {
			fontSize: 60,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF'
		}).setOrigin(0, 0.5);

		// Valore destro (avversario) - 1% dal bordo destro
		this.add.text(x + totalWidth * 0.99, y + height / 2, otherValueStr, {
			fontSize: 60,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF'
		}).setOrigin(1, 0.5);
	}

	showError(message) {
		var centerX = this.sys.game.config.width / 2;
		var centerY = this.sys.game.config.height / 2;

		this.add.text(
			centerX,
			centerY,
			message,
			{fontSize: 24, fontFamily: 'Luckiest Guy', fill: '#FF0000'}
		).setOrigin(0.5);

		// Bottone torna al menu
		var menuButton = new Button(
			this,
			centerX,
			centerY + 100,
			'red-button',
			1.2,
			'Torna alle sfide',
			false
		);

		var self = this;
		menuButton.on('pointerup', function() {
			self.scene.start('Challenge');
		});
	}
}
